import { type Message, strings } from "@quickpoint.me/shared";
import { useRecoilValue, waitForAll } from "recoil";
import { CurrentFilter, FontsAreLoaded } from "../state/filter";
import { HostId, IsPreviewGenerator } from "../state/ui";

import { useLayoutEffect, useRef } from "react";
import { useDebouncedCallback } from "use-debounce";
import { PageIndex } from "../state/page";
import { AllLoaded } from "../state/selectors";
import { RawCode } from "../state/stack";
import { postMessageToAuthor } from "./MessageHandler";

function PreviewRequester() {
	const hostId = useRecoilValue(HostId);
	const [allLoaded, pageIdx, isPreviewer, stack, fontsAreLoaded] =
		useRecoilValue(
			waitForAll([
				AllLoaded,
				PageIndex,
				IsPreviewGenerator,
				RawCode(strings.utility.inAuthor),
				FontsAreLoaded,
			]),
		);

	const currentFilter = useRecoilValue(CurrentFilter);
	const prevFilterName = useRef(currentFilter.filterName);

	const debounced = useDebouncedCallback(
		(message) => {
			postMessageToAuthor(message);
		},
		200,
		{ leading: true },
	);

	useLayoutEffect(() => {
		if (isPreviewer) {
			const message: Message = {
				hostId,
				type: "preview",
				action: strings.messages.restartPreview,
			};
			debounced(message);
		}
		prevFilterName.current = currentFilter.filterName;
	}, [isPreviewer, currentFilter.filterName, hostId, debounced]);

	useLayoutEffect(() => {
		if (isPreviewer && allLoaded && fontsAreLoaded && stack.code) {
			const message: Message = {
				hostId,
				type: "preview",
				action: strings.messages.requestPreviewSnap,
				payload: pageIdx,
			};
			debounced(message);
		}
	}, [
		fontsAreLoaded,
		allLoaded,
		isPreviewer,
		stack.code,
		pageIdx,
		debounced,
		hostId,
	]);

	return <></>;
}

export default PreviewRequester;
